/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import {
    successIconSrc,
    infoIconSrc,
    warningIconSrc,
    errorIconSrc,
    runningIconSrc,
    stoppedIconSrc,
    stoppingIconSrc,
    pendingIconSrc,
    startingIconSrc,
    updatingIconSrc,
    createdIconSrc,
    enabledIconSrc,
    acknowledgeIconSrc,
    backupAgentInstalledIconSrc,
    backupAgentNotInstalledIconSrc,
    unlicensedBackupServerIconSrc,
} from '../../icons';
import { ExtendedStatuses, StatusTypes } from './enums';
import { capitalize } from '../string-helpers';

const dotsStr = '...';

const getStatusIconSrc = (status: string): string => {
    if (typeof status !== 'string') {
        console.error(`Status "${status}" should be string, but it ${typeof status}`, new Error().stack);

        return '';
    }

    const parsedStatus: StatusTypes = ExtendedStatuses[capitalize(status.replace(dotsStr, '')).replace(/\s+/g, '')];

    switch (parsedStatus) {
        case (StatusTypes.Success): return successIconSrc;
        case (StatusTypes.Info): return infoIconSrc;
        case (StatusTypes.Warning): return warningIconSrc;
        case (StatusTypes.Error): return errorIconSrc;
        case (StatusTypes.Running): return runningIconSrc;
        case (StatusTypes.Syncing): return runningIconSrc;
        case (StatusTypes.Stopped): return stoppedIconSrc;
        case (StatusTypes.Stopping): return stoppingIconSrc;
        case (StatusTypes.Pending): return pendingIconSrc;
        case (StatusTypes.Starting): return startingIconSrc;
        case (StatusTypes.Updating): return updatingIconSrc;
        case (StatusTypes.Created): return createdIconSrc;
        case (StatusTypes.Enabled): return enabledIconSrc;
        case (StatusTypes.Acknowledged): return acknowledgeIconSrc;
        case (StatusTypes.Installed): return backupAgentInstalledIconSrc;
        case (StatusTypes.NotInstalled): return backupAgentNotInstalledIconSrc;
        case (StatusTypes.Unlicensed): return unlicensedBackupServerIconSrc;
        default: return '';
    }
};

const getStatusTitle = (lang: Record<string, string>, status: string): string => {
    const isDots = status.indexOf(dotsStr) !== -1;
    const statusTransformedToLangKey = status.replace(dotsStr, '').replace(/\s+/g, '_');

    return `${lang[statusTransformedToLangKey.toUpperCase()]}${isDots ? dotsStr : ''}`;
};

const divideStringToWords = (status: string): string => status.split(/(?=[A-Z])/).join(' ');

export {
    getStatusTitle,
    divideStringToWords,
    getStatusIconSrc,
};
